// extracted by mini-css-extract-plugin
export var headerCell = "_4i-1";
export var loadingSpinnerContainer = "_4i-4";
export var rowWrapper = "_4i-3";
export var standaloneTable = "_4i-5";
export var table = "_4i-0";
export var white = "_4i-2";